import React from 'react';

const StatusBadge = ({ status, size = 'default', className = '' }) => {
  const getStatusConfig = (status) => {
    const statusLower = status?.toLowerCase();
    
    switch (statusLower) {
      case 'draft':
        return {
          bgColor: 'bg-crystal-white border border-graphite/20',
          textColor: 'text-graphite',
          dotColor: 'bg-graphite',
          label: 'Draft'
        };
      case 'submitted':
        return {
          bgColor: 'bg-crystal-white border border-info/20',
          textColor: 'text-info',
          dotColor: 'bg-info',
          label: 'Submitted'
        };
      case 'under_review':
        return {
          bgColor: 'bg-crystal-white border border-warning/20',
          textColor: 'text-warning',
          dotColor: 'bg-warning',
          label: 'Under Review'
        };
      case 'missing_documents':
        return {
          bgColor: 'bg-crystal-white border border-steel/20',
          textColor: 'text-steel',
          dotColor: 'bg-steel',
          label: 'Pending Documents'
        };
      case 'approved':
        return {
          bgColor: 'bg-crystal-white border border-fresh-leaf/20',
          textColor: 'text-fresh-leaf',
          dotColor: 'bg-fresh-leaf',
          label: 'Approved'
        };
      case 'rejected':
        return {
          bgColor: 'bg-crystal-white border border-error/20',
          textColor: 'text-error',
          dotColor: 'bg-error',
          label: 'Rejected'
        };
      case 'payment_pending':
        return {
          bgColor: 'bg-crystal-white border border-zesty-lime/20',
          textColor: 'text-zesty-lime',
          dotColor: 'bg-zesty-lime',
          label: 'Payment Pending'
        };
      case 'paid':
        return {
          bgColor: 'bg-crystal-white border border-forest-fern/20',
          textColor: 'text-forest-fern',
          dotColor: 'bg-forest-fern',
          label: 'Paid'
        };
      case 'closed':
        return {
          bgColor: 'bg-crystal-white border border-woodland-moss/20',
          textColor: 'text-woodland-moss',
          dotColor: 'bg-woodland-moss',
          label: 'Closed'
        };
      case 'processing':
        return {
          bgColor: 'bg-crystal-white border border-zesty-lime/20',
          textColor: 'text-zesty-lime',
          dotColor: 'bg-zesty-lime',
          label: 'Processing'
        };
      case 'cancelled':
        return {
          bgColor: 'bg-crystal-white border border-graphite/20',
          textColor: 'text-graphite',
          dotColor: 'bg-graphite',
          label: 'Cancelled'
        };
      default:
        return {
          bgColor: 'bg-crystal-white border border-steel/20',
          textColor: 'text-steel',
          dotColor: 'bg-steel',
          label: status?.replace('_', ' ') || 'Unknown'
        };
    }
  };

  const getSizeClasses = (size) => {
    switch (size) {
      case 'small':
        return {
          container: 'px-2 py-1 text-xs',
          dot: 'h-1.5 w-1.5',
          spacing: 'gap-1'
        };
      case 'large':
        return {
          container: 'px-4 py-2 text-sm',
          dot: 'h-2.5 w-2.5',
          spacing: 'gap-2'
        };
      default:
        return {
          container: 'px-3 py-1.5 text-xs',
          dot: 'h-2 w-2',
          spacing: 'gap-1.5'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = getSizeClasses(size);

  if (!status) {
    return null;
  }

  return (
    <span
      className={`
        inline-flex items-center ${sizeClasses.spacing} ${sizeClasses.container}
        ${config.bgColor} ${config.textColor}
        font-medium tracking-wide uppercase
        ${className}
      `}
      title={`Status: ${config.label}`}
    >
      <span
        className={`
          ${sizeClasses.dot} ${config.dotColor}
          flex-shrink-0
        `}
        aria-hidden="true"
      />
      {config.label}
    </span>
  );
};

export default StatusBadge;
